module.exports = __webpack_public_path__ + "static/media/unnskyld.ea58b2c1.mp3";